import { defineMessages } from 'react-intl';

export const templatesSectionMessages = defineMessages({
	heading: {
		id: 'ConfluenceSoftwarePage.v4.TemplatesSection.heading',
		defaultMessage: 'Confluence is for every team',
	},
	seeAllTemplates: {
		id: 'ConfluenceSoftwarePage.v4.TemplatesSection.seeAllTemplates',
		defaultMessage: 'See all templates',
	},
	tryItOut: {
		id: 'ConfluenceSoftwarePage.v4.TemplatesSection.tryItOut',
		defaultMessage: 'Try it out',
	},
	expandAriaLabel: {
		id: 'ConfluenceSoftwarePage.v4.TemplatesSection.expandAriaLabel',
		defaultMessage: 'Expand {title}',
	},
	imgAlt: {
		id: 'ConfluenceSoftwarePage.v4.TemplatesSection.imgAlt',
		defaultMessage: 'Image of {title} template',
	},
});

export const templatesSectionMarketingMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.tabName',
		defaultMessage: 'Marketing',
	},
	contentHeading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.heading',
		defaultMessage: 'Templates for marketing teams',
	},
	template1Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.heading',
		defaultMessage: 'Marketing plan',
	},
	template1Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.description',
		defaultMessage: 'Nail your GTM strategy and plan marketing programs with your team',
	},
	template2Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.heading',
		defaultMessage: 'Competitive analysis',
	},
	template2Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.description',
		defaultMessage: 'Collaboratively document competitor offerings & strategies',
	},
	template3Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.heading',
		defaultMessage: 'Marketing campaign',
	},
	template3Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.description',
		defaultMessage: 'Build a solid campaign blueprint to drive impact',
	},
});

export const templatesSectionProjectPlanningMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.tabName',
		defaultMessage: 'Project Planning',
	},
	contentHeading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.heading',
		defaultMessage: 'Templates for project planning',
	},
	template1Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.heading',
		defaultMessage: 'Brainstorm',
	},
	template1Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.description',
		defaultMessage: 'Lead a productive brainstorming session and ideate on the most impactful work',
	},
	template2Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.heading',
		defaultMessage: 'Project plan',
	},
	template2Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.description',
		defaultMessage:
			'Map out your project logistics and move your team across the finish line, every time.',
	},
	template3Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.heading',
		defaultMessage: 'Roles & responsibilities',
	},
	template3Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.description',
		defaultMessage: 'Clarify individual roles and responsibilities to build a strong project team',
	},
});

export const templatesSectionSoftwareMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.tabName',
		defaultMessage: 'Software',
	},
	contentHeading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.heading',
		defaultMessage: 'Templates for software teams',
	},
	template1Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.heading',
		defaultMessage: 'Sprint planning',
	},
	template1Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.description',
		defaultMessage: 'Set goals, plan team capacity, and effectively kick off every sprint',
	},
	template2Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.heading',
		defaultMessage: 'Experiment plan',
	},
	template2Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.description',
		defaultMessage: 'Streamline your experiment process to more effectively test and learn',
	},
	template3Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.heading',
		defaultMessage: 'DevOps runbook',
	},
	template3Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.description',
		defaultMessage: 'Help your operations team respond to system alerts and outages',
	},
});

export const templatesSectionProductManagementMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.tabName',
		defaultMessage: 'Product Management',
	},
	contentHeading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.heading',
		defaultMessage: 'Templates for product management',
	},
	template1Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.heading',
		defaultMessage: 'Product requirements',
	},
	template1Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.description',
		defaultMessage: 'Outline your pre-launch prep and track your post-launch progress',
	},
	template2Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.heading',
		defaultMessage: 'Product roadmap',
	},
	template2Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.description',
		defaultMessage: 'Transform your product features from ideas to reality',
	},
	template3Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.heading',
		defaultMessage: 'Product launch',
	},
	template3Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.description',
		defaultMessage: 'Your ultimate liftoff planning doc',
	},
});

export const templatesSectionBusinessStrategyMessages = defineMessages({
	tabName: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.tabName',
		defaultMessage: 'Business Strategy',
	},
	contentHeading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.heading',
		defaultMessage: 'Templates for business strategy',
	},
	template1Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.heading',
		defaultMessage: 'Vision to values',
	},
	template1Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.description',
		defaultMessage: 'Align business strategies with company mission',
	},
	template2Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.heading',
		defaultMessage: 'Strategic plan',
	},
	template2Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.description',
		defaultMessage: 'Turn your business vision into actionable next steps',
	},
	template3Heading: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.heading',
		defaultMessage: 'Business status updates',
	},
	template3Description: {
		id: 'ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.description',
		defaultMessage: 'Share performance results and customer insights across the team',
	},
});
